<template>
    <div>
        <div>
            <div ref="panel" class="form-group card p-3">
                <div>
                    <label class="col-form-label">Baslik</label>
                    <i18n-text
                        :key="Math.random()"
                        :name="'visiting-point-title'"
                        :value="visitingPoint.title"
                        :create-hidden-input="false"
                    ></i18n-text>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Resim</label>
                    <div class="input-group">
                        <div
                            class="d-flex"
                            style="align-items: center; gap: 10px"
                        >
                            <label
                                :for="`files-${visitingPoint.id}`"
                                class="btn btn-default"
                                >Resim ekle</label
                            >
                            <img
                                style="width: 100px;"
                                id="upload-file-info"
                                readonly
                                v-if="
                                    visitingPoint.image &&
                                        visitingPoint.image.thumbnail
                                "
                                :src="
                                    `${image_service}${visitingPoint.image.thumbnail}`
                                "
                            />

                            <input
                                :key="Math.random()"
                                :id="`files-${visitingPoint.id}`"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg"
                                class="btn btn-default"
                                style="visibility:hidden;"
                                @change="preview($event, 'image')"
                            />

                            <button
                                :key="Math.random()"
                                v-if="visitingPoint.image"
                                class="btn btn-danger btn-sm"
                                type="button"
                                @click="deleteImage($event, 'image')"
                            >
                                <i class="material-icons">close</i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Görevler</label>
                    <i18n-textarea
                        :key="Math.random()"
                        :name="'visiting-point-missions'"
                        :value="visitingPoint.missions"
                        :create-hidden-input="false"
                    >
                    </i18n-textarea>
                </div>
                <div class="py-2">
                    <label class="col-form-label">Oyunlar</label>
                    <building-visiting-point-game-select
                        v-if="visitingPoint.showEditing"
                        :key="Math.random()"
                        :games="visitingPoint.games"
                        @update-games="updateGames"
                    ></building-visiting-point-game-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import buildingVisitingPointGameSelect from "./building-visiting-point-game-select.vue";
import i18nText from "./@components/i18n-text.vue";
import i18nTextarea from "./@components/i18n-textarea.vue";

export default {
    components: { buildingVisitingPointGameSelect, i18nText, i18nTextarea },
    props: ["editing-visiting-points"],
    data() {
        return {
            visitingPoint: {
                id: null,
                title: {},
                image: null,
                missions: {},
                games: []
            },
            image_service: process.env.MIX_BASE_IMAGE_SERVICE
        };
    },
    methods: {
        updateGames(games) {
            this.visitingPoint.games = games;
        },
        async preview(e, field) {
            const file = e.target.files[0];

            const formData = new FormData();
            formData.append("file", file);
            const options = {
                method: "POST",
                body: formData,
                headers: {
                    "X-CSRF-Token": document.querySelector(
                        'meta[name="csrf-token"]'
                    ).content
                }
            };
            let response = await fetch("/saveImageToStorage", options);
            let json = await response.json();
            this.visitingPoint[field] = json;
        },
        async deleteImage(e, field) {
            this.visitingPoint[field] = null;
        }
    },
    mounted() {
        this.visitingPoint = this.editingVisitingPoints;
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// resources/vue/building-visiting-point-editor.vue